export default {
    renderAs: {
        type: String,
        default: undefined
    },
    background: {
        type: String,
        default: undefined
    },
    border: {
        type: Object,
        default: undefined
    },
    checksum: {
        type: Boolean,
        default: undefined
    },
    color: {
        type: String,
        default: undefined
    },
    height: {
        type: Number,
        default: undefined
    },
    padding: {
        type: Object,
        default: undefined
    },
    text: {
        type: Object,
        default: undefined
    },
    type: {
        type: String,
        default: undefined
    },
    value: {
        type: [Number, String],
        default: undefined
    },
    width: {
        type: Number,
        default: undefined
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-barcodes-vue-wrapper/src/KendoBarcode/BarcodeProps.js